module.exports = __webpack_public_path__ + "img/business.09adf3c0.jpg";